<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer006">
<p class="centered"><span class="bold _idGenCharOverride-1">Also by Basil Sands</span></p>
<p class="centered"><span class="italics _idGenCharOverride-1"><br/></span></p>
<p class="centered"><span class="italics _idGenCharOverride-1">65 Below</span></p>
<p class="centered"><span class="italics _idGenCharOverride-1">Karl’s Last Flight</span></p>
<p class="centered"><span class="italics _idGenCharOverride-1">Ice Hammer </span>series</p>
<p class="centered"><span class="italics _idGenCharOverride-1">Invasion</span></p>
<p class="centered"><span class="italics _idGenCharOverride-1">Insurgent</span></p>
<p class="centered"><span class="italics _idGenCharOverride-1">Faithful Warrior</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?7aff6fea